'use client';

import { UserManagementIcon } from '@repo/icons';
import * as TenantCookies from '@repo/tenancy/cookies';
import { TENANTS_DATA } from '@repo/tenancy/data';
import type { TenantInfo } from '@repo/tenancy/types';
import { Button } from '@repo/ui/button';
import { Dialog, DialogContent, DialogTrigger } from '@repo/ui/dialog';
import { DialogTitle } from '@repo/ui/dialog';
import { TabItem } from '@repo/ui/tab-item';
import { format } from 'date-fns-tz';
import { useMemo, useState } from 'react';
import { TENANT_COOKIE_NAME } from '@/constants';
import { env } from '@/lib/env';

const TenantSwitcher = () => {
  const [open, setOpen] = useState(false);

  const activeTenantName = useMemo(() => {
    try {
      const activeTenantString = TenantCookies.cookies.get(TENANT_COOKIE_NAME);
      const nameFromCookie = activeTenantString ? JSON.parse(activeTenantString).name : TENANTS_DATA[0].name;
      return nameFromCookie ?? TENANTS_DATA[0].name;
    } catch {
      return TENANTS_DATA[0].name;
    }
  }, []);

  const handleTenantSelect = (tenant: TenantInfo) => {
    TenantCookies.cookies.set(tenant, TENANT_COOKIE_NAME);
    setOpen(false);
    window.location.reload();
  };

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
    >
      <DialogTrigger asChild>
        <Button
          variant="blank"
          className="fixed bottom-20 right-5 z-50 h-10 w-10 flex-shrink-0 rounded-full !bg-green-500 p-0 shadow-[0_6px_16px_rgba(0,0,0,0.90)] hover:!bg-green-800 sm:bottom-10 sm:right-8"
          data-testid="tenant-switcher"
        >
          <UserManagementIcon className="h-4 w-4 text-white" />
        </Button>
      </DialogTrigger>
      <DialogContent
        dir="ltr"
        className="max-w-80 gap-0"
      >
        <DialogTitle className="p-2 text-base font-semibold">Choose Tenant</DialogTitle>
        {TENANTS_DATA.map((tenant, index) => (
          <TabItem
            key={tenant.id}
            disabled={activeTenantName === tenant.machineName}
            isActive={activeTenantName === tenant.machineName}
            className="flex w-full flex-col items-start justify-between rounded-none p-2"
            onClick={() => handleTenantSelect(tenant as TenantInfo)}
            data-testid="tenant-menu-item"
          >
            <div className="flex w-full flex-col">
              <div className="flex w-full flex-wrap items-start text-left">
                <span className="text-base font-medium">{`${index + 1}.  ${tenant.name}`}</span>
              </div>
              {/* TODO: Temporary disabled */}
              {/* <div className="text-muted-foreground highlight-none mt-1 max-h-[60px] w-full overflow-y-auto whitespace-pre-wrap break-all text-left vt-text-size-small">
                {JSON.stringify(tenant, null, 2)}
              </div> */}
            </div>
          </TabItem>
        ))}
        <span className="border-t border-t-[#6b06aa] p-1 font-bold text-white vt-font-highlight-font-family vt-text-size-small-sm">
          {`Build Date - ${format(new Date(env.NEXT_PUBLIC_BUILD_DATE), 'dd MMMM yyyy | HH:mm:ss')}`}
        </span>
      </DialogContent>
    </Dialog>
  );
};

export default TenantSwitcher;
